import React from 'react';

export type UserTabId = 'principal' | 'seguindo' | 'torneios' | 'jogos';

interface UserTabsProps {
  activeTab: UserTabId;
  onTabChange: (tab: UserTabId) => void;
  principalContent?: React.ReactNode;
  seguindoContent?: React.ReactNode;
  torneiosContent?: React.ReactNode;
  jogosContent?: React.ReactNode;
}

const placeholder = (
  <div className="text-center py-4">
    <p className="text-muted">Em breve</p>
  </div>
);

const UserTabs: React.FC<UserTabsProps> = ({
  activeTab,
  onTabChange,
  principalContent,
  seguindoContent,
  torneiosContent,
  jogosContent,
}) => {
  return (
    <div className="card w-100 shadow-xss rounded-xxl border-0 mb-3">
      <div className="card-body p-0">
        {/* Abas */}
        <ul className="nav nav-tabs border-0 px-3 pt-3" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === 'principal' ? 'active' : ''}`}
              id="principal-tab"
              type="button"
              role="tab"
              aria-controls="principal"
              aria-selected={activeTab === 'principal'}
              onClick={() => onTabChange('principal')}
            >
              Principal
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === 'seguindo' ? 'active' : ''}`}
              id="seguindo-tab"
              type="button"
              role="tab"
              aria-controls="seguindo"
              aria-selected={activeTab === 'seguindo'}
              onClick={() => onTabChange('seguindo')}
            >
              Seguindo
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === 'torneios' ? 'active' : ''}`}
              id="torneios-tab"
              type="button"
              role="tab"
              aria-controls="torneios"
              aria-selected={activeTab === 'torneios'}
              onClick={() => onTabChange('torneios')}
            >
              Torneios
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === 'jogos' ? 'active' : ''}`}
              id="jogos-tab"
              type="button"
              role="tab"
              aria-controls="jogos"
              aria-selected={activeTab === 'jogos'}
              onClick={() => onTabChange('jogos')}
            >
              Jogos
            </button>
          </li>
        </ul>

        {/* Divisória */}
        <div className="border-top"></div>

        {/* Conteúdo das Abas */}
        <div className="tab-content p-3">
          <div
            className={`tab-pane fade ${activeTab === 'principal' ? 'show active' : ''}`}
            id="principal"
            role="tabpanel"
            aria-labelledby="principal-tab"
          >
            {principalContent ?? placeholder}
          </div>
          <div
            className={`tab-pane fade ${activeTab === 'seguindo' ? 'show active' : ''}`}
            id="seguindo"
            role="tabpanel"
            aria-labelledby="seguindo-tab"
          >
            {seguindoContent ?? placeholder}
          </div>
          <div
            className={`tab-pane fade ${activeTab === 'torneios' ? 'show active' : ''}`}
            id="torneios"
            role="tabpanel"
            aria-labelledby="torneios-tab"
          >
            {torneiosContent ?? placeholder}
          </div>
          <div
            className={`tab-pane fade ${activeTab === 'jogos' ? 'show active' : ''}`}
            id="jogos"
            role="tabpanel"
            aria-labelledby="jogos-tab"
          >
            {jogosContent ?? placeholder}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserTabs;
